import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  useCompanyReportsTimePeriodsList,
  useOrganizationTimePeriodsList,
} from '@shared/api/lib/company-reports/company-reports';

export const useGetOrganizationTimePeriods = () => {
  return useOrganizationTimePeriodsList({ request: useAxiosConfig() });
};

export const useGetCompanyReportPeriods = (companyReportUuid: string) => {
  return useCompanyReportsTimePeriodsList(companyReportUuid, {
    request: useAxiosConfig(),
    query: {
      enabled: !!companyReportUuid,
      staleTime: Infinity,
    },
  });
};
